import { SettingsService } from "../../services/settings.service";
import { S25Util } from "../../util/s25-util";
import { PreferenceService } from "../../services/preference.service";
import {
    ChangeDetectorRef,
    Component,
    OnInit,
    ElementRef,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    inject,
} from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { ServicePortalService } from "../../services/service.portal.service";
import { Bind } from "../../decorators/bind.decorator";

@TypeManagerDecorator("s25-ng-service-portal")
@Component({
    selector: "s25-ng-service-portal",
    template: `
        @if (init) {
            <div class="c-margin-bottom--double service-portal">
                <div>
                    <h2 class="c-margin-bottom--single">Service Portal</h2>

                    <p class="ngBold c-margin-bottom--quarter c-margin-top--single">Create a Lynx User</p>
                    <s25-ng-lynx-users></s25-ng-lynx-users>

                    <!--Freshbooks -->
                    <s25-ng-freshbooks-config></s25-ng-freshbooks-config>

                    <div class="section c-margin-bottom--quarter c-margin-top--single">
                        <p class="ngBold">Cache Management</p>
                        <s25-spring-cache></s25-spring-cache>
                        <s25-ng-button class="fitContent" [type]="'primary'" [onClick]="clearRulesCache">
                            Clear Rules Cache
                        </s25-ng-button>
                        <div>
                            <a
                                href="http://25live-web.collegenet.com:8080/25saas/25live/data/devel/run/internal/trees/cache_flush_all.json"
                                target="_blank"
                                class="aw-button aw-button--primary"
                            >
                                Clear Rules Cache For All Instances
                            </a>
                            <p class="ngFinePrint">
                                Clearing for all instances only works when connected to the CollegeNET VPN
                            </p>
                        </div>
                    </div>

                    <p class="ngBold c-margin-bottom--quarter c-margin-top--single">Set X25 Access</p>
                    <s25-ng-checkbox
                        [(value)]="x25Enabled"
                        (valueChange)="setX25Access()"
                        aria-label="Enable Full X25 Access"
                        >Enable Full X25 Analytics Access</s25-ng-checkbox
                    >

                    <p class="ngBold c-margin-bottom--quarter c-margin-top--single">Set Optimizer Access</p>
                    <s25-ng-checkbox
                        [(value)]="optimizerEnabled"
                        (valueChange)="setOptimizerAccess()"
                        aria-label="Enable Optimizer Access"
                        >Enable Optimizer Access</s25-ng-checkbox
                    >

                    <div class="ngBold c-margin-bottom--quarter c-margin-top--single">Eval25</div>
                    <s25-ng-checkbox [(value)]="eval25Enabled" (valueChange)="saveEval25()"
                        >Eval25 Location Satisfaction</s25-ng-checkbox
                    >

                    <div class="ngBold c-margin-bottom--quarter c-margin-top--single">Has Connect25</div>
                    <s25-ng-checkbox [(value)]="hasStudentEngagement" (valueChange)="saveStudentEngagement()"
                        >Has Connect25</s25-ng-checkbox
                    >

                    <div class="ngBold c-margin-bottom--quarter c-margin-top--single">SIS Interface</div>
                    <p class="ngFinePrint c-margin-bottom--quarter c-margin-left--single">
                        Turns on TCS only features including
                    </p>
                    <ul class="ngFinePrint c-margin-left--double">
                        <li>System Settings > Integrations > SIS Import/Export</li>
                        <li>Event Bulk Edit - Export to SIS</li>
                        <li>Event Bulk Edit - Back to Back Binding</li>
                    </ul>
                    <s25-ng-checkbox [(value)]="hasLegacyInterface" (valueChange)="saveLegacyInterface()"
                        >Uses TCS Interface</s25-ng-checkbox
                    >

                    <p class="ngBold c-margin-top--single">Set Beta Access</p>
                    <p class="ngFinePrint c-margin-bottom--quarter c-margin-left--double">
                        Turns on access to beta features
                    </p>

                    <s25-ng-preference-toggle
                        class="wrapper c-displayInlineBlock c-margin-left--double"
                        prefName="HasBetaFeatures"
                        prefType="S"
                        [label]="'Full Beta Feature Access'"
                    ></s25-ng-preference-toggle>

                    <div class="ngBold c-margin-bottom--quarter c-margin-top--single">JReport Server Settings</div>
                    <label for="jrserverInst" class="c-margin-bottom--quarter">JR Report Server Instance Name</label
                    ><br />
                    <input name="jrserverInst" [(ngModel)]="jrserverInst" type="text" class="c-input" /><br />
                    <label for="jrserverUrl" class="c-margin-bottom--quarter">JR Report Server URL</label><br />
                    <input
                        name="jrserverUrl"
                        [(ngModel)]="jrserverUrl"
                        type="text"
                        class="c-input ng-pristine ng-valid ng-scope ng-empty ng-valid-maxlength ng-touched"
                    /><br />
                    <button
                        class="aw-button aw-button--primary c-margin-top--single c-margin-bottom--quarter"
                        (click)="saveReportSettings()"
                    >
                        Save Report Settings
                    </button>

                    <p class="ngBold c-margin-top--single">Copy Database</p>
                    <s25-ng-copy-series-database></s25-ng-copy-series-database>

                    <s25-ng-se-demo-data></s25-ng-se-demo-data>

                    <div class="c-margin-bottom--quarter c-margin-top--single">
                        <s25-ng-errors></s25-ng-errors>
                    </div>
                </div>
            </div>
        }
    `,
    styles: [
        `
            .service-portal {
                input[type="text"] {
                    width: 60%;
                    max-width: 400px;
                }
                s25-ng-editable-text {
                    width: 100%;
                    input {
                        min-width: 400px;
                    }
                }
            }

            .section {
                display: grid;
                gap: 0.5rem;
            }

            .fitContent {
                width: fit-content;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false,
    providers: [ServicePortalService],
})
export class S25ServicePortalComponent implements OnInit {
    // PREFS = ["HasBetaFeatures", "config_jrserver_inst", "config_jrserver_url"];
    init = false;

    readonly service = inject(ServicePortalService);

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {}

    async ngOnInit() {
        this.elementRef.nativeElement.angBridge = this;

        SettingsService.getSettings().then((settings) => {
            this.x25Enabled = S25Util.toBool(settings.CAN_USE_X25);
            this.eval25Enabled = S25Util.toBool(settings.CAN_USE_EVAL25);
            this.optimizerEnabled = S25Util.toBool(settings.CAN_USE_OPTIMIZER);
            this.hasLegacyInterface = S25Util.toBool(settings.HAS_LEGACY_SIS);
            this.hasStudentEngagement = S25Util.toBool(settings.HAS_STUDENT_ENGAGEMENT);
        });

        this.getReportSettings();
        this.init = true;
        this.cd.detectChanges();
    }

    hasStudentEngagement: boolean;
    saveStudentEngagement() {
        return SettingsService.setSetting("HAS_STUDENT_ENGAGEMENT", this.hasStudentEngagement ? 1 : 0);
    }

    //SIS Interface
    hasLegacyInterface: boolean;
    saveLegacyInterface() {
        return SettingsService.setSetting("HAS_LEGACY_SIS", this.hasLegacyInterface ? 1 : 0);
    }

    eval25Enabled: boolean;
    saveEval25() {
        return SettingsService.setSetting("CAN_USE_EVAL25", this.eval25Enabled ? 1 : 0);
    }

    //x25
    x25Enabled: boolean;
    setX25Access() {
        //https://collegenet.atlassian.net/wiki/spaces/X25/pages/21659721/Licenses+and+Functionality
        return SettingsService.setSetting("CAN_USE_X25", this.x25Enabled ? 1 : 0);
    }

    //Optimizer
    optimizerEnabled: boolean;
    async setOptimizerAccess() {
        return SettingsService.setSetting("CAN_USE_OPTIMIZER", this.optimizerEnabled ? 1 : 0);
    }

    //Reports
    jrserverInst: string;
    jrserverUrl: string;
    getReportSettings() {
        PreferenceService.getPreferences(["config_jrserver_inst", "config_jrserver_url"], "S").then((prefs) => {
            this.jrserverInst = prefs["config_jrserver_inst"].value;
            this.jrserverUrl = prefs["config_jrserver_url"].value;
        });
    }

    async saveReportSettings() {
        await S25Util.all({
            inst: PreferenceService.setPreference("config_jrserver_inst", this.jrserverInst, "S"),
            url: PreferenceService.setPreference("config_jrserver_url", this.jrserverUrl, "S"),
        });
        this.getReportSettings();
    }

    @Bind
    async clearRulesCache() {
        const [_, error] = await S25Util.Maybe(this.service.clearRulesCache());
        if (error) S25Util.showError(error);
    }

    @Bind
    async clearRulesCacheAll() {
        const [_, error] = await S25Util.Maybe(this.service.clearRulesCacheAll());
        if (error) S25Util.showError(error);
    }
}
